import React from "react";

type Props = {
  className?: string;
};
export const MagicIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 17 17" fill="none">
      <g clipPath="url(#clip0_1570_17651)">
        <path d="M13.8394 5.71093L11.289 3.16052C10.625 2.49646 9.53548 2.49646 8.87142 3.16052L1.03551 11.0235C0.371449 11.6876 0 12.5643 0 13.494C0 15.4333 1.56676 17 3.50597 17C4.43566 17 5.31243 16.6286 5.97649 15.9645L13.8395 8.1015C14.5036 7.43744 14.5035 6.37499 13.8394 5.71093ZM4.48868 14.4765C4.22305 14.7421 3.87753 14.875 3.50608 14.875C2.73619 14.875 2.12505 14.2638 2.12505 13.4939C2.12505 13.1225 2.28484 12.777 2.52348 12.5113L6.77347 8.26135L8.71274 10.2006L4.48868 14.4765ZM10.2267 8.71275L8.28742 6.77348L10.0939 4.96703L12.0331 6.90629L10.2267 8.71275Z" />
        <path d="M14.8749 0L14.1309 1.38103L12.7499 2.12499L14.1309 2.86895L14.8749 4.24999L15.6188 2.86895L16.9999 2.12499L15.6188 1.38103L14.8749 0Z" />
        <path d="M15.1404 9.82812L14.4764 11.0234L13.2811 11.6875L14.4764 12.3515L15.1404 13.5468L15.8045 12.3515L16.9998 11.6875L15.8045 11.0234L15.1404 9.82812Z" />
        <path d="M6.24206 2.52343L7.43737 1.85937L6.24206 1.19531L5.578 0L4.91394 1.19531L3.71863 1.85937L4.91394 2.52343L5.578 3.71874L6.24206 2.52343Z" />
      </g>
    </svg>
  );
};
